import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppRoutesName } from '../../const/AppRoutesName';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.OPERATIONS,
    loadComponent: () =>
      import('./dashboard-operations.component').then(
        (m) => m.DashboardOperationsComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.OPERATIONS,
    loadComponent: () =>
      import('./dashboard-operations.component').then(
        (m) => m.DashboardOperationsComponent,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardOperationsModule {}
